/** Shared result helpers for MCP tool handlers. */

export function textResult(text: string): { content: { type: "text"; text: string }[] } {
  return { content: [{ type: "text" as const, text }] };
}

export function imageBlock(
  data: string,
  mimeType: string,
): { type: "image"; data: string; mimeType: string } {
  return { type: "image" as const, data, mimeType };
}

export function isImageMimeType(mimeType: string): boolean {
  return mimeType.startsWith("image/");
}

// ── Event formatting for CLI logs ─────────────────────────────────────

type EventRecord = Record<string, unknown>;

const cliEventFormatters: Record<string, (e: EventRecord) => string> = {
  thinking: (e) => (e.message as string) ?? "",
  tool_use: (e) => `${e.tool}: ${(e.input as string)?.slice(0, 1000) ?? ""}`,
  tool_result: (e) =>
    `${e.tool} → ${(e.output as string)?.slice(0, 500) ?? ""}${e.isError ? " [ERROR]" : ""}`,
  message: (e) => (e.content as string) ?? "",
  error: (e) => `ERROR: ${(e.message as string) ?? ""}`,
  completed: (e) =>
    `Completed: ${(e.summary as string) ?? ""} (cost: $${e.costUsd ?? "?"}, duration: ${e.durationMs ?? "?"}ms)`,
  setup_output: (e) => `[${(e.stream as string) ?? "stdout"}] ${(e.data as string) ?? ""}`,
  start_command_output: (e) => `[${(e.stream as string) ?? "stdout"}] ${(e.data as string) ?? ""}`,
  turn_end: (e) => `Turn complete (${(e.toolCalls as unknown[])?.length ?? 0} tool calls)`,
};

export function formatCliEvent(e: EventRecord): string {
  const formatter = cliEventFormatters[e.type as string];
  return formatter ? formatter(e) : JSON.stringify(e);
}
